var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "#E31837",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9272 13.9395C22.8917 13.8581 22.8419 13.7837 22.7803 13.7198L18.2802 9.21975C18.2163 9.15809 18.1419 9.10831 18.0605 9.07275C18.038 9.06225 18.014 9.05625 17.99 9.048C17.9272 9.02664 17.8619 9.01378 17.7957 9.00975C17.78 9.00825 17.7657 9 17.75 9H12.5C11.6727 9 11 9.67275 11 10.5V22.5C11 23.3273 11.6727 24 12.5 24H21.5C22.3273 24 23 23.3273 23 22.5V14.25C23 14.2343 22.9917 14.22 22.9902 14.2035C22.9866 14.1373 22.9737 14.0719 22.952 14.0092C22.9445 13.9852 22.9377 13.962 22.9272 13.9395ZM20.4395 13.5H18.5V11.5605L20.4395 13.5ZM12.5 22.5V10.5H17V14.25C17 14.4489 17.079 14.6397 17.2197 14.7803C17.3603 14.921 17.5511 15 17.75 15H21.5L21.5015 22.5H12.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.5H20V18H14V16.5ZM14 19.5H20V21H14V19.5ZM14 13.5H15.5V15H14V13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.b5176526bcc89e7673e25f1cf44dec3b.svg";
export { ForwardRef as ReactComponent };